module.exports = __webpack_public_path__ + "static/media/thumblr.b1c50ee9.svg";